module.exports = __webpack_public_path__ + "static/media/hero-image.40900237.png";